import React from 'react';
import { COLORS } from '../../constants';
import { PAGE, getCardStyle } from '../ui';
import StackBar from './StackBar';

export default function StatusCard({ title, good, damaged, empty, total }) {
  const rows = [
    { label: 'Total', val: total, color: total > 0 ? COLORS.blue : COLORS.slate },
    { label: 'Good', val: good, color: COLORS.green },
    { label: 'Damaged', val: damaged, color: COLORS.red },
    { label: 'Empty', val: empty, color: COLORS.slate },
  ];

  return (
    <div
      style={{
        flex: 1,
        ...getCardStyle(),
        padding: '12px 14px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '118px',
      }}
    >
      <div
        style={{
          ...PAGE.type.cardLabel,
          marginBottom: 8,
          fontSize: 11,
          fontWeight: 700,
        }}
      >
        {title}
      </div>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 5,
          marginBottom: 8,
        }}
      >
        {rows.map((item) => (
          <div key={item.label} style={{ textAlign: 'center' }}>
            <div
              style={{
                ...PAGE.type.metricValue,
                color: item.color,
                fontSize: 18,
                lineHeight: '20px',
                fontWeight: 800,
              }}
            >
              {item.val}
            </div>

            <div
              style={{
                fontSize: 9,
                color: PAGE.colors.muted,
                marginTop: 3,
                fontWeight: 600,
                lineHeight: '11px',
              }}
            >
              {item.label}
            </div>
          </div>
        ))}
      </div>

      <div style={{ marginTop: 'auto' }}>
        <StackBar good={good} damaged={damaged} empty={empty} total={total} />
      </div>
    </div>
  );
}